import React from "react";
import { Input } from "antd";
import Status from "../status";
import { Field } from "formik";
import PropTypes from "prop-types";
import style from "./style.module.scss";

const CurrencyIcon = () => {
  return (
    <div className={style['currency-icon-container']}>
      <div className={style['currency-icon']}>₹</div>
    </div>
  )
}

const FieldInput = ({
  name,
  label,
  type,
  placeholder,
  isRequired = false,
  isUnit,
  showError = true,
  isPrice = false,
  isDisabled = false,
  onKeyPress = () => {},
  ...restProps
}) => (
  <Field name={name}>
    {({ field, meta: { error, touched }, x }) => {
      return (
        <div className={style["input-wrapper"]} style={isPrice ? {marginTop: '2px'} : null}>
          {label ? (
            <p className={style.label}>
              <span>{label}</span>
              {isRequired && <Status isFilled={!error && !!field?.value} />}
            </p>
          ) : null}
            
          {
            isPrice && 
            <CurrencyIcon />
          }
          <div className={style["box"]}>
            <Input
              status={touched && error ? "error" : ""}
              type={type}
              className={isUnit ? style.secondinput : style.input}
              placeholder={placeholder}
              onWheel={(event) => event.currentTarget.blur()}
              onKeyPress={onKeyPress}
              style={isPrice ? {paddingLeft: '30px', marginTop: '-8px'} : null}
              disabled={isDisabled}
              {...field}
              {...restProps}
            />
            {isUnit && <div className={style["unit"]}>{isUnit}</div>}
          </div>
          {touched && error && showError ? <p className={style.error}>{error}</p> : null}
        </div>
      );
    }}
  </Field>
);

FieldInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  type: PropTypes.oneOf(["text", "password", "number"]),
  placeholder: PropTypes.string,
};

FieldInput.defaultProps = {
  type: "text",
};

export default FieldInput;
